import { ValidationInterface } from '../../validation.interface';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import { AdditionalProduct, AddProdPropName } from '../../../../models/project/plant-specifications/additional-product.model';

export class AdditionalProductValidation implements ValidationInterface {
  /** The current product obj that is being validated */
  private readonly product: AdditionalProduct;

  /**
   * Sets the product obj that will be used for validation
   * @param product will be used to set the current product obj
   */
  constructor(product: AdditionalProduct) {
    if (!product) throw Error('invalid product provided for validation');
    this.product = new AdditionalProduct(product);
  }

  /**
   * Get a validation unit containing the validation data for the current value obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.product) throw Error('unable to validate product');
    const validationUnit = new ProjectValidationUnit();
       if (this.product.name) {
         validationUnit.setValid(AddProdPropName.name);
       } else {
         validationUnit.setInvalid(AddProdPropName.name, [AddProductError.MissingName]);
       }

       if (this.product.parentProduct) {
         validationUnit.setValid(AddProdPropName.parentProduct);
       } else {
         validationUnit.setInvalid(AddProdPropName.parentProduct);
       }

       validationUnit.addModuleResults(
         new UnitValueValidation(this.product.quantity).getValidation(),
         AddProdPropName.quantity
       );

       validationUnit.addModuleResults(
         new UnitValueValidation(this.product.quantityPer).getValidation(),
         AddProdPropName.quantityPer
       );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current product obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}

/**
 * An enum that contains error that relate to product errors
 */
export enum AddProductError {
  MissingName = 'VALIDATION.MISSING_NAME',
  MissingType = 'VALIDATION.MISSING_TYPE',
  MissingInRelationTo = 'VALIDATION.MISSING_INRELATIONTO'
}
